// API
import { HTTP } from "./http";

export const requestBecomeReviewer = (model) => {

  const formData = new FormData();

  formData.append(`identity_card`, model.identity_card[0]);
  formData.append(`dental_license`, model.dental_license[0]);
  formData.append(`specialty_certificate`, model.specialty_certificate[0]);

  return new Promise((resolve, reject) => HTTP.post(`/reviewer_status_requests`, formData)
    .then(response => ((response.status === 201) ? resolve : reject)(response))
    .catch(error => reject(error.response)));
};

export const getReviewerRequests = (url = false) => new Promise((resolve, reject) => HTTP.get(url || `/reviewer_status_requests`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getReviewerRequestById = (id) => new Promise((resolve, reject) => HTTP.get(`/reviewer_status_requests/${id}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const submitReviewerRequestDecision = model => new Promise((resolve, reject) => HTTP.post(`/reviewer_status_requests/${model.id}/review`, model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/reviewer.js